import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    businessSlug: String,
    businessName: String,
    businessCategory: String,
    businessCity: String
  }

  connect() {
    this.trackPageView()
    this.trackGoogleAnalytics()
  }

  async trackPageView() {
    try {
      const response = await fetch(`/businesses/${this.businessSlugValue}/increment_view`, {
        method: 'PATCH',
        headers: {
          'X-CSRF-Token': this.getCsrfToken(),
          'Content-Type': 'application/json'
        }
      })
      
      if (!response.ok) {
        console.warn('Failed to increment view count')
      }
    } catch (error) {
      console.warn('Could not track page view:', error)
    }
  }

  trackGoogleAnalytics() {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'page_view', {
        'page_title': this.businessNameValue,
        'page_location': window.location.href,
        'business_category': this.businessCategoryValue,
        'business_city': this.businessCityValue
      })
    }
  }

  getCsrfToken() {
    return document.querySelector('[name="csrf-token"]')?.content || ''
  }
}
